<template>
  <div>
    <h1 class="title mqu-subtitle">
      Ingoing/Entry Fees
    </h1>
    <h2 class="subtitle">
      It might be called a purchase price or a loan to the village operator.
    </h2>
    <ingoing-fee v-model="data.ingoingFee" v-on:input="update"/>
  </div>
</template>

<script>
import IngoingFee from '../inputs/ingoing-fees/IngoingFee'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    IngoingFee
  },
  data() {
    return {
      data: {
        ingoingFee: this.value.ingoingFee
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/IngoingFees.vue